import {
  ChartModificationItem,
  DeleteModificationItem,
  ImageModificationItem,
  InputModificationItem,
  ListModificationItem,
  LockModificationItem,
  StyleModificationItem,
  TextModificationItem,
  UnlockModificationItem,
  VisibilityModificationItem,
} from '@carboncopyco/editor-ui';
import { type IDynamicEditData, IDynamicEditType } from '@carboncopyco/types';

const editsTypeToComponent: Record<
  IDynamicEditData['type'],
  | typeof TextModificationItem
  | typeof ChartModificationItem
  | typeof ImageModificationItem
  | typeof ListModificationItem
  | typeof StyleModificationItem
  | typeof InputModificationItem
  | typeof VisibilityModificationItem
  | typeof DeleteModificationItem
  | typeof LockModificationItem
  | typeof UnlockModificationItem
  | 'div'
> = {
  [IDynamicEditType.text]: TextModificationItem,
  [IDynamicEditType.chart]: ChartModificationItem,
  [IDynamicEditType.image]: ImageModificationItem,
  [IDynamicEditType.list]: ListModificationItem,
  [IDynamicEditType.style]: StyleModificationItem,
  [IDynamicEditType.input]: InputModificationItem,
  [IDynamicEditType.visibility]: VisibilityModificationItem,
  [IDynamicEditType.delete]: DeleteModificationItem,
  [IDynamicEditType.lock]: LockModificationItem,
  [IDynamicEditType.unlock]: UnlockModificationItem,
  [IDynamicEditType.link]: 'div',
};

export const SpotEditsPreview = ({
  edit,
  id,
}: { edit: IDynamicEditData; id?: string }) => {
  const Preview = editsTypeToComponent[edit.type];
  return Preview ? (
    <Preview
      edit={edit.element}
      id={id}
    />
  ) : null;
};
